<ng-container *ngIf="formGroup != null" [formGroup]="formGroup">
    <div *ngFor="let equipment of equipments; let i = index">
        <sc-checkbox-field formControlName="cb-{{equipment.id}}" labelDictionaryKey="dd.SUPPLEMENTARYEQUIPMENT.{{equipment.id}}.name"></sc-checkbox-field>
    </div>
    <div *ngIf="!equipments || equipments.length === 0">
      <sc-dictionary-label dictionaryKey="tmc-common.ui.filter-admin.condition.has-supplementary-equipment.no-equipment-defined"></sc-dictionary-label>
    </div>
</ng-container>
